import studiesActions from './actionTypes.js'
import studiesMutations from './mutationTypes.js'
import http from '../../../services/http'
import apiFunctions from '../../../helpers/apiFunctions.js'
import generalActions from '../general/actionTypes.js'

const actions = {
  [studiesActions.FETCH_STUDIES]: async ({ dispatch }, { sq, fullSq }) => {
    const response = await http.post('/smartsearch/', { query: sq, full_query: fullSq })
    const responseObject = apiFunctions.checkIfResponseFailed(response)
    if (!responseObject.failed) {
      return response.data
    } else {
      dispatch(generalActions.SET_ERROR)
    }
  },
  [studiesActions.FETCH_FIELDS]: async ({ dispatch, commit }) => {
    const response = await http.post('/smartsearch/dropdown_options', { query: [], full_query: [] })
    const responseObject = apiFunctions.checkIfResponseFailed(response)
    if (!responseObject.failed) {
      commit(studiesMutations.SET_SEARCH_FIELDS, response.data.fields)
      return response.data
    } else {
      dispatch(generalActions.SET_ERROR)
    }
  },
  [studiesActions.FETCH_STUDY_SUMMARIES]: async ({ dispatch, commit }, sq) => {
    const response = await http.post('/smartsearch/study_summarises', { query: sq })
    const responseObject = apiFunctions.checkIfResponseFailed(response)
    if (!responseObject.failed) {
      commit(studiesMutations.SET_STUDY_SUMMARIES, response.data)
      return response.data
    } else {
      dispatch(generalActions.SET_ERROR)
    }
  },
  [studiesActions.FETCH_FRAGRANCES]: async ({ dispatch, commit }, sq) => {
    const response = await http.post('/smartsearch/fragrances', { query: sq })
    const responseObject = apiFunctions.checkIfResponseFailed(response)
    if (!responseObject.failed) {
      commit(studiesMutations.SET_FRAGRANCES, response.data)
      return response.data
    } else {
      dispatch(generalActions.SET_ERROR)
    }
  },
  [studiesActions.FETCH_CONCEPTS]: async ({ dispatch, commit }, sq) => {
    const response = await http.post('/smartsearch/concepts', { query: sq })
    const responseObject = apiFunctions.checkIfResponseFailed(response)
    if (!responseObject.failed) {
      commit(studiesMutations.SET_CONCEPTS, response.data)
      return response.data
    } else {
      dispatch(generalActions.SET_ERROR)
    }
  },
  [studiesActions.SET_FRAGRANCES]: async ({ commit }, data) => {
    commit(studiesMutations.SET_FRAGRANCES_DETAILS, data)
  },
  [studiesActions.SET_CONCEPTS]: async ({ commit }, data) => {
    commit(studiesMutations.SET_CONCEPTS_DETAILS, data)
  },
  [studiesActions.FETCH_FILES]: async ({ dispatch, commit }, { sq, fullSq, fileType }) => {
    const response = await http.post(`/smartsearch/files/${fileType}`, { query: sq, full_query: fullSq })
    const responseObject = apiFunctions.checkIfResponseFailed(response)
    if (!responseObject.failed) {
      commit(studiesMutations.SET_FILES, { fileType, data: response.data })
      return response.data
    } else {
      dispatch(generalActions.SET_ERROR)
    }
  },
  [studiesActions.QUEUE_METRIC_SEARCH]: async ({ dispatch, commit }, { q, data, noCache }) => {
    const response = await http.post(
      `/analytics/fragrances`,
      data ? { ...q, fragrances: data } : q,
      { params: { ...(noCache ? { no_cache: true } : {}) } }
    )
    const responseObject = apiFunctions.checkIfResponseFailed(response)
    if (!responseObject.failed) {
      commit(studiesMutations.SET_STUDY_SUMMARIES, response.data.results)
      commit(studiesMutations.SET_JOB_ID, { job: 'metrics', id: response.data.jobid })
    } else {
      dispatch(generalActions.SET_ERROR)
    }
  },
  [studiesActions.QUEUE_METRIC_SEARCH_AND_GET_JOB_ID]: async ({ dispatch, commit }, { q, data, noCache }) => {
    const response = await http.post(
      `/analytics/fragrances`,
      data ? { ...q, fragrances: data } : q,
      { params: { ...(noCache ? { no_cache: true } : {}) } }
    )
    const responseObject = apiFunctions.checkIfResponseFailed(response)
    if (!responseObject.failed) {
      commit(studiesMutations.SET_STUDY_SUMMARIES, response.data.results)
      return response.data.jobid
    } else {
      dispatch(generalActions.SET_ERROR)
    }
  },
  [studiesActions.QUEUE_PERFORMANCE_SEARCH]: async ({ dispatch, commit }, { q, data, frags, noCache }) => {
    const response = await http.post(
      `/analytics/fragrances`,
      { ...q, grouping: [data], fragrances: frags },
      { params: { ...(noCache ? { no_cache: true } : {}) } }
    )
    const responseObject = apiFunctions.checkIfResponseFailed(response)
    if (!responseObject.failed) {
      commit(studiesMutations.SET_STUDY_SUMMARIES, response.data.results)
      commit(studiesMutations.SET_JOB_ID, { job: 'performance', id: response.data.jobid })
    } else {
      dispatch(generalActions.SET_ERROR)
    }
  },
  [studiesActions.QUEUE_ATTRIBUTES_SEARCH]: async ({ dispatch, commit }, { q, data, frags, noCache }) => {
    const query = {
      query: q.query,
      demographics: q.demographics,
      responses: q.responses,
      metrics: q.metrics,
      ...data,
      frags
    }
    const response = await http.post(
      `/analytics/top-attributes`,
      query,
      { params: { no_cache: true } }
    )
    const responseObject = apiFunctions.checkIfResponseFailed(response)
    if (!responseObject.failed) {
      commit(studiesMutations.SET_JOB_ID, { job: 'attributes', id: response.data.jobid })
    } else {
      dispatch(generalActions.SET_ERROR)
    }
  },
  [studiesActions.FETCH_TENDENCIES]: async ({ dispatch, commit }, { q, data, frags, noCache }) => {
    const query = {
      query: q.query,
      metrics: q.metrics,
      ...data,
      frags
    }
    const response = await http.post(
      `/analytics/tendencies`,
      query,
      { params: { ...(noCache ? { no_cache: true } : {}) } }
    )
    const responseObject = apiFunctions.checkIfResponseFailed(response)
    if (!responseObject.failed) {
      commit(studiesMutations.SET_ANALYTICS_DATA, { type: 'tendencies', data: response.data })
    } else {
      dispatch(generalActions.SET_ERROR)
    }
  },
  // [studiesActions.CHECK_METRIC_JOB_STATUS]: async ({ dispatch, commit }, jobId) => {
  //   const response = await http.get(`/analytics/fragrances/${jobId}`)
  //   const responseObject = apiFunctions.checkIfResponseFailed(response)
  //   if (!responseObject.failed) {
  //     if (response.data.status === 'SUCCESS') {
  //       const results = (
  //         response &&
  //         response.data &&
  //         response.data.result &&
  //         response.data.result.json
  //       ) ? response.data.result.json : {}
  //       commit(studiesMutations.SET_ANALYTICS_DATA, { type: 'metrics', data: results })
  //       return true
  //     }
  //     return ['FAILURE', 'REVOKED'].includes(response.data.status)
  //   } else {
  //     dispatch(generalActions.SET_ERROR)
  //   }
  // },

  [studiesActions.CHECK_METRIC_JOB_STATUS]: async ({ dispatch, commit }, jobId) => {
    try {
      const response = await http.get(`/analytics/fragrances/${jobId}`)
      if (typeof response.data === 'string') {
        response.data = response.data.replace(/,\s*([\]}])/g, '$1')
        response.data = response.data.replace(/-Infinity/g, -9999)
        response.data = JSON.parse(response.data)
      }
      const responseObject = apiFunctions.checkIfResponseFailed(response)

      if (!responseObject.failed) {
        if (response.data.status === 'SUCCESS') {
          const results = (response && response.data && response.data.result && response.data.result.json)
            ? response.data.result.json
            : {}
          commit(studiesMutations.SET_ANALYTICS_DATA, { type: 'metrics', data: results })
          return true
        }

        return ['FAILURE', 'REVOKED'].includes(response.data.status)
      }

      dispatch(generalActions.SET_ERROR)
    } catch (error) {
      console.error('An error occurred:', error)
    }
  },
  [studiesActions.CHECK_STUDY_FILE_UPLOAD_STATUS]: async ({ dispatch, commit }, { jobId, studyId }) => {
    try {
      const response = await http.get(`/study/${studyId}/upload/${jobId}`)
      return response.data
    } catch (err) {
      if (err.response.data && err.response.data.message) {
        return err.response.data.message
      }
      return { 'status': 'failed' }
    }
  },
  [studiesActions.CHECK_METRIC_JOB_STATUS_AND_GET_DATA]: async ({ dispatch, commit }, jobId) => {
    const response = await http.get(`/analytics/fragrances/${jobId}`)
    const responseObject = apiFunctions.checkIfResponseFailed(response)
    if (!responseObject.failed) {
      if (response.data.status === 'SUCCESS') {
        return response.data
      }
      return ['FAILURE', 'REVOKED'].includes(response.data.status)
    } else {
      dispatch(generalActions.SET_ERROR)
    }
  },
  [studiesActions.CHECK_PERFORMANCE_JOB_STATUS]: async ({ dispatch, commit }, jobId) => {
    try {
      console.log('Dispatching CHECK_PERFORMANCE_JOB_STATUS with jobId:', jobId)

      // Make GET request to endpoint
      const response = await http.get(`/analytics/fragrances/${jobId}`)
      console.log('Response from server:', response)

      // Check if response indicates failure
      const responseObject = apiFunctions.checkIfResponseFailed(response)
      console.log('Response object:', responseObject)

      if (!responseObject.failed) {
        // Check if job status is SUCCESS
        if (response.data.status === 'SUCCESS') {
          console.log('Job status is SUCCESS. Setting analytics data.')

          // Commit mutation to set analytics data
          commit(studiesMutations.SET_ANALYTICS_DATA, { type: 'performance', data: response.data.result.json.results })

          // Return true to indicate success
          return true
        }
        console.log('Job status is not SUCCESS:', response.data.status)

        // Return true if job status is FAILURE or REVOKED
        return ['FAILURE', 'REVOKED'].includes(response.data.status)
      } else {
        console.log('Response indicates failure. Dispatching SET_ERROR action.')

        // Dispatch SET_ERROR action if response indicates failure
        dispatch(generalActions.SET_ERROR)
      }
    } catch (error) {
      console.error('An error occurred:', error)
      // Handle error if needed
    }
  },
  // [studiesActions.CHECK_PERFORMANCE_JOB_STATUS]: async ({ dispatch, commit }, jobId) => {
  //   const response = await http.get(`/analytics/fragrances/${jobId}`)
  //   const responseObject = apiFunctions.checkIfResponseFailed(response)
  //   if (!responseObject.failed) {
  //     if (response.data.status === 'SUCCESS') {
  //       commit(studiesMutations.SET_ANALYTICS_DATA, { type: 'performance', data: response.data.result.json.results })
  //       return true
  //     }
  //     return ['FAILURE', 'REVOKED'].includes(response.data.status)
  //   } else {
  //     dispatch(generalActions.SET_ERROR)
  //   }
  // },
  [studiesActions.CHECK_ATTRIBUTES_JOB_STATUS]: async ({ dispatch, commit }, jobId) => {
    const response = await http.get(`/analytics/top-attributes/${jobId}`)
    const responseObject = apiFunctions.checkIfResponseFailed(response)
    if (!responseObject.failed) {
      if (response.data.status === 'SUCCESS') {
        commit(studiesMutations.SET_ANALYTICS_DATA, { type: 'attributes', data: response.data.result.json })
        return true
      }
      return ['FAILURE', 'REVOKED'].includes(response.data.status)
    } else {
      dispatch(generalActions.SET_ERROR)
    }
  },
  [studiesActions.CHECK_METRIC_XLSX_JOB_STATUS]: async ({ dispatch, commit }, { jobId, filters, metricThreshold }) => {
    const response = await http({
      url: `/analytics/fragrances/xlsx/${jobId}`,
      method: 'GET',
      params: {
        filters: filters,
        thresholdMetrics: metricThreshold ? metricThreshold.metrics : [],
        thresholdValue: metricThreshold ? metricThreshold.value : null
      },
      responseType: 'blob'
    })
    const responseObject = apiFunctions.checkIfResponseFailed(response)
    if (!responseObject.failed) {
      return response.data
    } else {
      dispatch(generalActions.SET_ERROR)
    }
  },
  [studiesActions.CHECK_PERFORMANCE_XLSX_JOB_STATUS]: async ({ dispatch, commit }, jobId) => {
    const response = await http({
      url: `/analytics/fragrances/xlsx/${jobId}`,
      method: 'GET',
      responseType: 'blob'
    })
    const responseObject = apiFunctions.checkIfResponseFailed(response)
    if (!responseObject.failed) {
      return response.data
    } else {
      dispatch(generalActions.SET_ERROR)
    }
  },
  [studiesActions.CHECK_ATTRIBUTES_XLSX_JOB_STATUS]: async ({ dispatch, commit }, jobId) => {
    const response = await http({
      url: `/analytics/top-attributes/xlsx/${jobId}`,
      method: 'GET',
      responseType: 'blob'
    })
    const responseObject = apiFunctions.checkIfResponseFailed(response)
    if (!responseObject.failed) {
      return response.data
    } else {
      dispatch(generalActions.SET_ERROR)
    }
  },
  [studiesActions.FETCH_SUMMARIES_XLSX]: async ({ dispatch, commit }, { q }) => {
    const response = await http({
      url: `/smartsearch/download_study_summarises`,
      method: 'POST',
      data: q,
      responseType: 'blob'
    })
    const responseObject = apiFunctions.checkIfResponseFailed(response)
    if (!responseObject.failed) {
      if (!response.data.status) {
        return response.data
      }
      return false
    } else {
      dispatch(generalActions.SET_ERROR)
    }
  },
  [studiesActions.FETCH_FRAGRANCE_XLSX]: async ({ dispatch, commit }, { q }) => {
    const response = await http({
      url: `/smartsearch/download_fragrances`,
      method: 'POST',
      data: q,
      responseType: 'blob'
    })
    const responseObject = apiFunctions.checkIfResponseFailed(response)
    if (!responseObject.failed) {
      if (!response.data.status) {
        return response.data
      }
      return false
    } else {
      dispatch(generalActions.SET_ERROR)
    }
  },
  [studiesActions.FETCH_FRAGRANCE_XLSX_FILTERS]: async ({ dispatch }) => {
    const response = await http.get(`/analytics/fragrances/xlsxfilters`)
    const responseObject = apiFunctions.checkIfResponseFailed(response)
    if (!responseObject.failed) {
      return response.data
    } else {
      dispatch(generalActions.SET_ERROR)
    }
  },
  [studiesActions.FETCH_CICS_QUESTIONS]: async ({ dispatch, commit }, q) => {
    const response = await http.post(`/cics/search_bar/`, q)
    const responseObject = apiFunctions.checkIfResponseFailed(response)
    if (!responseObject.failed) {
      commit(studiesMutations.SET_CICS, response.data)
    } else {
      dispatch(generalActions.SET_ERROR)
    }
  },
  [studiesActions.FETCH_CICS_QUESTION_DATA]: async ({ dispatch, commit }, { q, id }) => {
    const response = await http.post(`/cics/inspect_question/${id}/`, q)
    const responseObject = apiFunctions.checkIfResponseFailed(response)
    if (!responseObject.failed) {
      return response.data
    } else {
      dispatch(generalActions.SET_ERROR)
    }
  },
  [studiesActions.FETCH_ANALYTICS_FIELDS]: async ({ dispatch }) => {
    const response = await http.get(`/analytics/options`)
    const responseObject = apiFunctions.checkIfResponseFailed(response)
    if (!responseObject.failed) {
      return response.data
    } else {
      dispatch(generalActions.SET_ERROR)
    }
  },
  [studiesActions.FETCH_CICS_FIELDS]: async ({ dispatch }) => {
    const response = await http.get(`/cics/options`)
    const responseObject = apiFunctions.checkIfResponseFailed(response)
    if (!responseObject.failed) {
      return response.data
    } else {
      dispatch(generalActions.SET_ERROR)
    }
  },
  [studiesActions.FETCH_QUESTIONS]: async ({ dispatch, commit }, id) => {
    const response = await http.get('/study/' + id + '/questions/')
    const responseObject = apiFunctions.checkIfResponseFailed(response)
    if (!responseObject.failed) {
      commit(studiesMutations.SET_QUESTIONS, response.data)
    } else {
      dispatch(generalActions.SET_ERROR)
    }
  },
  [studiesActions.CLEAR_QUESTIONS]: async ({ dispatch, commit }) => {
    commit(studiesMutations.SET_QUESTIONS, [])
  },
  [studiesActions.FETCH_METRICS]: async ({ dispatch }) => {
    const response = await http.get('/study/metrics/')
    const responseObject = apiFunctions.checkIfResponseFailed(response)
    if (!responseObject.failed) {
      return response.data
    } else {
      dispatch(generalActions.SET_ERROR)
    }
  },
  [studiesActions.FETCH_FRAGRANCE_PROFILE]: async ({ dispatch }, { id, code, data }) => {
    let response = null
    try {
      response = await http.post(
        `/study/${id}/fragrance/${code}`,
        data,
        { timeout: 60000 }
      )
    } catch (e) {
      response = e.response || e
    }
    if (!response || typeof response.status !== 'number' || response.status >= 400) {
      dispatch(generalActions.SET_ERROR, response)
      return null
    }
    const responseObject = apiFunctions.checkIfResponseFailed(response)
    if (!responseObject.failed) {
      return response.data
    } else {
      dispatch(generalActions.SET_ERROR, response)
      return null
    }
  },
  [studiesActions.FETCH_CONCEPT_PROFILE]: async ({ dispatch }, { id, code, data }) => {
    let response = null
    try {
      response = await http.post(
        `/study/${id}/concept/${code}`,
        data,
        { timeout: 60000 }
      )
    } catch (e) {
      response = e.response || e
    }
    if (!response || typeof response.status !== 'number' || response.status >= 400) {
      dispatch(generalActions.SET_ERROR, response)
      return null
    }
    const responseObject = apiFunctions.checkIfResponseFailed(response)
    if (!responseObject.failed) {
      return response.data
    } else {
      dispatch(generalActions.SET_ERROR, response)
      return null
    }
  },
  [studiesActions.SET_OR_CLEAR_SEARCH_FILTERS]: async ({ dispatch, commit }, { clearFilters, filters }) => {
    if (clearFilters) {
      commit(studiesMutations.RESET_SEARCH_FILTERS)
    } else {
      commit(studiesMutations.SET_SEARCH_FILTERS, filters)
    }
  },
  [studiesActions.RESET_SEARCH_FILTERS]: async ({ commit }) => {
    commit(studiesMutations.RESET_SEARCH_FILTERS)
  },
  [studiesActions.APPLY_SEARCH_FILTERS]: async ({ commit }, filters) => {
    commit(studiesMutations.APPLY_SEARCH_FILTERS, filters)
  },
  [studiesActions.UPDATE_CICS_FILTERS]: async ({ commit }, filters) => {
    commit(studiesMutations.SET_CICS_FILTERS, filters)
  },
  [studiesActions.RESET_CICS_FILTERS]: async ({ commit }) => {
    commit(studiesMutations.RESET_CICS_FILTERS)
  },
  [studiesActions.APPLY_CICS_FILTERS]: async ({ commit }, filters) => {
    commit(studiesMutations.APPLY_CICS_FILTERS, filters)
  },
  [studiesActions.CLEAR_STUDY_SUMMARIES]: async ({ commit }) => {
    commit(studiesMutations.CLEAR_STUDY_SUMMARIES)
  },
  [studiesActions.CLEAR_FRAGRANCES]: async ({ commit }) => {
    commit(studiesMutations.CLEAR_FRAGRANCES)
  },
  [studiesActions.CLEAR_CONCEPTS]: async ({ commit }) => {
    commit(studiesMutations.CLEAR_CONCEPTS)
  },
  [studiesActions.CLEAR_FILES]: async ({ commit }) => {
    commit(studiesMutations.CLEAR_FILES)
  },
  [studiesActions.CLEAR_ANALYTICS]: async ({ commit }) => {
    commit(studiesMutations.CLEAR_ANALYTICS)
  },
  [studiesActions.FETCH_STUDY_FILES]: async ({ dispatch }, id) => {
    const response = await http.get('/study/' + id + '/study-files/')
    const responseObject = apiFunctions.checkIfResponseFailed(response)
    if (!responseObject.failed) {
      return response.data
    } else {
      dispatch(generalActions.SET_ERROR)
    }
  },
  [studiesActions.FETCH_RELATED_STUDY_FILES]: async ({ dispatch }, id) => {
    const response = await http.get('/study/' + id + '/related-study-files/')
    const responseObject = apiFunctions.checkIfResponseFailed(response)
    if (!responseObject.failed) {
      return response.data
    } else {
      dispatch(generalActions.SET_ERROR)
    }
  },
  [studiesActions.FETCH_STUDY_TAGS]: async ({ dispatch, commit }) => {
    const response = await http.get('/study/options')
    const responseObject = apiFunctions.checkIfResponseFailed(response)
    if (!responseObject.failed) {
      commit(studiesMutations.SET_STUDY_TAGS, response.data)
    } else {
      dispatch(generalActions.SET_ERROR)
    }
  },
  [studiesActions.FETCH_STUDY_DETAILS]: async ({ dispatch, commit }, id) => {
    const response = await http.get('/study/' + id)
    const responseObject = apiFunctions.checkIfResponseFailed(response)
    if (!responseObject.failed) {
      commit(studiesMutations.SET_STUDY_DETAILS, response.data)
    } else {
      dispatch(generalActions.SET_ERROR)
    }
  },
  [studiesActions.UPDATE_STUDY_DETAILS]: async ({ dispatch }, { id, data }) => {
    const response = await http.put('/study/' + id, data)
    const responseObject = apiFunctions.checkIfResponseFailed(response)
    if (!responseObject.failed) {
      return response.data
    } else {
      dispatch(generalActions.SET_ERROR)
    }
  },
  [studiesActions.UPDATE_STUDY_MAPPING]: async ({ dispatch }, { id, query }) => {
    let response = null
    try {
      response = await http.put('/study/' + id + '/question/', { q_upd: query })
    } catch (e) {
      response = e.response || e
    }
    if (!response || typeof response.status !== 'number' || response.status >= 400) {
      dispatch(generalActions.SET_ERROR, response)
      return null
    }
    const responseObject = apiFunctions.checkIfResponseFailed(response)
    if (!responseObject.failed) {
      return response
    } else {
      dispatch(generalActions.SET_ERROR, response)
      return null
    }
  },
  [studiesActions.UPDATE_DROPDOWN_OPTIONS]: async ({ dispatch }, { query = [] } = {}) => {
    let response = null
    try {
      response = await http.post('/smartsearch/dropdown_options', { query }, { timeout: 30000 })
    } catch (e) {
      response = e.response || e
    }
    if (!response || typeof response.status !== 'number' || response.status >= 400) {
      dispatch(generalActions.SET_ERROR, response)
      return { data: { fields: [] } }
    }
    const responseObject = apiFunctions.checkIfResponseFailed(response)
    if (!responseObject.failed) {
      return response
    } else {
      dispatch(generalActions.SET_ERROR, response)
      return { data: { fields: [] } }
    }
  },
  [studiesActions.UPDATE_METRICS_DROPDOWN_OPTIONS]: async ({ dispatch }, payload = {}) => {
    const {
      query = [],
      queryMetrics,
      query_metrics: legacyQueryMetrics,
      rdfType,
      irtImplict
    } = payload
    const normalizedMetricsQuery = queryMetrics ?? legacyQueryMetrics ?? []
    let response = null
    try {
      response = await http.post(
        '/smartsearch/dropdown_options_analytics',
        {
          query: query,
          query_metrics: normalizedMetricsQuery,
          rdf_type: rdfType,
          irt_implict: irtImplict
        },
        { timeout: 30000 }
      )
    } catch (e) {
      response = e.response || e
    }
    if (!response || typeof response.status !== 'number' || response.status >= 400) {
      dispatch(generalActions.SET_ERROR, response)
      return { data: { fields: [] } }
    }
    const responseObject = apiFunctions.checkIfResponseFailed(response)
    if (!responseObject.failed) {
      return response
    } else {
      dispatch(generalActions.SET_ERROR, response)
      return { data: { fields: [] } }
    }
  },
  [studiesActions.FETCH_SAVED_SEARCHES]: async ({ dispatch, commit }, { userId, type }) => {
    const response = await http.get(`/users/${userId}/searches/`, { params: { search_type: type } })
    const responseObject = apiFunctions.checkIfResponseFailed(response)
    if (!responseObject.failed) {
      commit(studiesMutations.SET_SAVED_SEARCHES, response)
    } else {
      dispatch(generalActions.SET_ERROR)
    }
  },
  [studiesActions.FETCH_STUDIES_COUNT]: async ({ dispatch, commit }) => {
    const response = await http.get(`/smartsearch/count`)
    const responseObject = apiFunctions.checkIfResponseFailed(response)
    if (!responseObject.failed) {
      commit(studiesMutations.SET_STUDIES_COUNT, response)
    } else {
      dispatch(generalActions.SET_ERROR)
    }
  },
  [studiesActions.POST_SAVED_SEARCH]: async ({ dispatch }, { userId, data, type }) => {
    const response = await http.post(`/users/${userId}/searches/`, { ...data, search_type: type })
    const responseObject = apiFunctions.checkIfResponseFailed(response)
    if (!responseObject.failed) {
      if (response.status === 200) {
        dispatch(studiesActions.FETCH_SAVED_SEARCHES, { userId, type })
      }
      return response
    } else {
      dispatch(generalActions.SET_ERROR)
    }
  },
  [studiesActions.POST_TAG_EDIT]: async ({ dispatch, commit }, { studyId, data, tagKey }) => {
    let response
    try {
      response = await http.put(`/study/${studyId}`, data)
    } catch (e) {
      let errorMessage
      if (e.response) {
        errorMessage = e.response.status === 400 ? e.response.data : 'Something went wrong, please try again later.'
      } else {
        errorMessage = 'Something went wrong, please try again later.'
      }
      commit(studiesMutations.SET_STUDY_ERROR, { message: errorMessage, key: tagKey || 'main' })
      return e.response
    }
    const responseObject = apiFunctions.checkIfResponseFailed(response)
    if (!responseObject.failed) {
      if (response.status === 200) {
        commit(studiesMutations.UPDATE_STUDY_DETAILS, data)
      }
      commit(studiesMutations.SET_STUDY_ERROR, null)
      return true
    } else {
      dispatch(generalActions.SET_ERROR)
      return responseObject.data
    }
  },
  [studiesActions.DELETE_SAVED_SEARCH]: async ({ dispatch }, { userId, data, type }) => {
    const response = await http.delete(`/users/${userId}/searches/`, { data })
    const responseObject = apiFunctions.checkIfResponseFailed(response)
    if (!responseObject.failed) {
      if (response.status === 200) {
        dispatch(studiesActions.FETCH_SAVED_SEARCHES, { userId, type })
      }
    } else {
      dispatch(generalActions.SET_ERROR)
    }
  },
  [studiesActions.FETCH_FILE]: async ({ dispatch }, { studyId, fileId }) => {
    const response = await http({
      url: '/study/' + studyId + '/study-files/' + fileId,
      method: 'GET',
      responseType: 'blob'
    })
    const responseObject = apiFunctions.checkIfResponseFailed(response)
    if (!responseObject.failed) {
      return response.data
    } else {
      dispatch(generalActions.SET_ERROR)
    }
  },
  [studiesActions.EDIT_STUDIES]: async ({ dispatch }, data) => {
    const response = await http.put('/smartsearch/update', data)
    const responseObject = apiFunctions.checkIfResponseFailed(response)
    if (!responseObject.failed) {
      return response.data
    } else {
      dispatch(generalActions.SET_ERROR)
    }
  },
  [studiesActions.FETCH_TENDENCIES_XLSX]: async ({ dispatch }, { q, data, frags }) => {
    const query = {
      query: q.query,
      metrics: q.metrics,
      ...data,
      frags
    }
    const response = await http({
      url: '/analytics/tendencies/xlsx',
      method: 'POST',
      responseType: 'blob',
      data: query
    })
    const responseObject = apiFunctions.checkIfResponseFailed(response)
    if (!responseObject.failed) {
      return response.data
    } else {
      dispatch(generalActions.SET_ERROR)
    }
  },
  [studiesActions.GET_FRAGRANCE_PROFILE_XLSX]: async ({ dispatch }, { id, code, q }) => {
    const response = await http({
      url: `/study/${id}/fragrance/${code}/xlsx`,
      method: 'POST',
      responseType: 'blob',
      data: q
    })
    const responseObject = apiFunctions.checkIfResponseFailed(response)
    if (!responseObject.failed) {
      return response.data
    } else {
      dispatch(generalActions.SET_ERROR)
    }
  },
  [studiesActions.QUEUE_SIGNIFICANCE_CALCULATION]: async ({ dispatch, commit }, { q, data }) => {
    const query = {
      fragrances: data,
      calculation: q.calculation,
      metrics: q.metrics
    }
    const response = await http.post('/analytics/significance', query)
    const responseObject = apiFunctions.checkIfResponseFailed(response)
    if (!responseObject.failed) {
      commit(studiesMutations.SET_JOB_ID, { job: 'significance', id: response.data.job_id })
    } else {
      dispatch(generalActions.SET_ERROR)
    }
  },
  [studiesActions.CHECK_SIGNIFICANCE_JOB_STATUS]: async ({ dispatch, commit }, { jobId }) => {
    const response = await http.get(`/analytics/significance/${jobId}`)
    const responseObject = apiFunctions.checkIfResponseFailed(response)
    if (!responseObject.failed) {
      const status = response.data.status
      if (status === 'SUCCESS' || status === 'completed' || !status) {
        commit(studiesMutations.SET_SIGNIFICANCE_RESULTS, response.data.result ? response.data.result.results : response.data.results)
        return true
      }
      if (status === 'failed' || status === 'FAILURE') {
        return true
      }
      return false
    } else {
      dispatch(generalActions.SET_ERROR)
    }
  },
  [studiesActions.UPLOAD_STUDIES]: async ({ dispatch }, { file, form, onProgress }) => {
    const formData = new FormData()
    formData.append('file', file)
    for (const key in form) {
      formData.append(key, form[key])
    }
    const response = await http.post('/fileprocess/studies_upload', formData, {
      onUploadProgress: progressEvent => {
        const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total)
        if (onProgress) onProgress(percentCompleted)
      }
    })
    const responseObject = apiFunctions.checkIfResponseFailed(response)
    if (!responseObject.failed) {
      return response.data
    } else {
      dispatch(generalActions.SET_ERROR)
    }
  },
  [studiesActions.FETCH_PROCESS_FILE_DETAILS]: async ({ dispatch, commit }, { fileProcessId }) => {
    try {
      const response = await http.get(`/fileprocess/file-process/${fileProcessId}`)
      const responseObject = apiFunctions.checkIfResponseFailed(response)
      if (!responseObject.failed) {
        return response.data
      } else {
        dispatch(generalActions.SET_ERROR, response)
        return null
      }
    } catch (error) {
      dispatch(generalActions.SET_ERROR, error.response || error)
      return null
    }
  },
  [studiesActions.UPDATE_FILE_PROCESS]: async ({ dispatch, commit }, { fileProcessId, filePath, file, onProgress }) => {
    try {
      const formData = new FormData()
      formData.append('filepath', filePath)
      formData.append('file', file)
      const response = await http.put(`/fileprocess/fileprocess/${fileProcessId}/replace_file`, formData, {
        onUploadProgress: progressEvent => {
          const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total)
          if (onProgress) onProgress(percentCompleted)
        }
      })
      const responseObject = apiFunctions.checkIfResponseFailed(response)
      if (!responseObject.failed) {
        return response.data
      } else {
        dispatch(generalActions.SET_ERROR, response)
        return null
      }
    } catch (error) {
      dispatch(generalActions.SET_ERROR, error.response || error)
      return null
    }
  },
  [studiesActions.PROCESS_STUDIES]: async ({ dispatch, commit }, { fileProcessId, onProgress }) => {
    try {
      const response = await http.post(`/fileprocess/fileprocess/${fileProcessId}/process_studies`, {}, {
        onUploadProgress: progressEvent => {
          const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total)
          if (onProgress) onProgress(percentCompleted)
        }
      })
      const responseObject = apiFunctions.checkIfResponseFailed(response)
      if (!responseObject.failed) {
        return response.data
      } else {
        dispatch(generalActions.SET_ERROR, response)
        return null
      }
    } catch (error) {
      dispatch(generalActions.SET_ERROR, error.response || error)
      return null
    }
  },
  [studiesActions.DOWNLOAD_FILE_FROM_FILE_PROCESS]: async ({ dispatch, commit }, { processId, filePath }) => {
    const filepath = btoa(filePath)
    const response = await http({
      url: `/fileprocess/${processId}/${filepath}/download`,
      method: 'GET',
      responseType: 'blob'
    })
    const responseObject = apiFunctions.checkIfResponseFailed(response)
    if (!responseObject.failed) {
      return response.data
    } else {
      dispatch(generalActions.SET_ERROR)
    }
  },
  [studiesActions.SEND_RDF_DATA]: async ({ dispatch, commit }, { dataForm, studyId = '' }) => {
    const formData = new FormData()

    Object.keys(dataForm).forEach(key => formData.append(key, dataForm[key]))
    if (studyId) formData.append('study_id', studyId)

    const response = await http.post('/rdf/rdf_upload', formData)
    const responseObject = apiFunctions.checkIfResponseFailed(response)
    if (!responseObject.failed) return response.data
    else dispatch(generalActions.SET_ERROR)
  },
  [studiesActions.FETCH_FILE_PROCESS]: async ({ dispatch }) => {
    // per_page=100: the list endpoint now returns a lightweight schema (no
    // tasks_meta_data/file_tree), so a larger page is cheap and gives the
    // client-side table's pagination real history to page through instead
    // of being artificially capped to the first few rows.
    const response = await http({
      url: '/fileprocess/file-processes',
      method: 'GET',
      params: { per_page: 100 }
    })
    const responseObject = apiFunctions.checkIfResponseFailed(response)
    if (!responseObject.failed) return response.data
    else dispatch(generalActions.SET_ERROR)
  },
  [studiesActions.GET_STUDY_METRICS]: async ({ dispatch }, { studyId }) => {
    try {
      const response = await http({
        url: `/study/metrics/${studyId}`,
        method: 'GET'
      })
      const responseObject = apiFunctions.checkIfResponseFailed(response)
      if (!responseObject.failed) return response.data
      else dispatch(generalActions.SET_ERROR)
      return null
    } catch {
      return null
    }
  },
  [studiesActions.FETCH_STUDY_EDIT_HISTORY]: async ({ dispatch, commit }, id) => {
    const response = await http({
      url: `/study/study_edit_history/${id}`,
      method: 'GET'
    })
    const responseObject = apiFunctions.checkIfResponseFailed(response)
    if (!responseObject.failed) return response.data
    else dispatch(generalActions.SET_ERROR)
  },
  [studiesActions.UPLOAD_RDF_DATA]: async ({ dispatch }, { formData, method }) => {
    let response
    if (method.toLowerCase() === 'post') {
      response = await http.post('/rdf/rdf_file_metrics', formData)
    } else if (method.toLowerCase() === 'put') {
      response = await http.put('/rdf/rdf_file_metrics', formData)
    }
    const responseObject = apiFunctions.checkIfResponseFailed(response)
    if (!responseObject.failed) return response.data
    else dispatch(generalActions.SET_ERROR)
  },
  [studiesActions.CHECK_ALL_CLOSE_ENDED_QUESTIONS]: async ({ dispatch }, { formData }) => {
    const response = await http.post('/rdf/check_all_close_ended_questions', formData)
    const responseObject = apiFunctions.checkIfResponseFailed(response)
    if (!responseObject.failed) return response.data
    else dispatch(generalActions.SET_ERROR)
  }
}

export default {
  ...actions
}
